module.exports = __webpack_public_path__ + "img/9788958101291.aa960332.jpg";